module.exports = __webpack_public_path__ + "img/ordered-list.c314210d.svg";